import { AnalyticsController } from 'analytics/analytics-controller';

/**
 * Higher-order function that wraps a function and tracks an event before execution
 *
 * @param eventName The name of the event to track
 * @param fn The function to wrap
 *
 * @returns A new function that tracks the event and then executes the original function
 */
export function withEventTracking<T extends (...args: unknown[]) => unknown>(eventName: string, fn: T
): (...args: Parameters<T>) => ReturnType<T> {
  return (...args: Parameters<T>): ReturnType<T> => {
    AnalyticsController.trackEvent(eventName);
    return fn(...args) as ReturnType<T>;
  };
}

/**
 * Higher-order function that returns a no-op function that only tracks an event
 *
 * @param eventName The name of the event to track
 *
 * @returns A new function that tracks the event and then does nothing
 */
export function withNoOpEventTracking(eventName: string): () => void {
  return () => {
    AnalyticsController.trackEvent(eventName);
  };
}